import { OrderDirection, TableHeader } from '@beego/ngx-table';
import { translate } from '@shared-libs/helpers';

export class LocationTableFactory {
	public static getHeaders(): Array<TableHeader> {
		return [
			new TableHeader(translate('LOCATION.PLACE'), ['place', OrderDirection.asc], 4),
			new TableHeader(translate('LOCATION.COMMENT'), ['comment'], 5),
			new TableHeader(translate('LOCATION.ADDRESS'), ['Address', 'street'], 5),
			new TableHeader(),
		];
	}
}
